<template>
  <el-form ref="ff" v-loading="loading" :model="detail" label-width="80px">
    <el-form-item label="客户名称" prop="Name" required>
      <el-input v-model="detail.Name" clearable />
    </el-form-item>
    <el-form-item label="客户类型" prop="Mode" required>
      <el-radio-group v-model="detail.Mode">
        <el-radio :label="0">一般客户</el-radio>
        <el-radio :label="1">经销商</el-radio>
      </el-radio-group>
    </el-form-item>
    <el-form-item label="机构代码" prop="Code">
      <el-input v-model="detail.Code" clearable placeholder="统一社会信用代码" />
    </el-form-item>
    <el-form-item label="开户银行" prop="Bank">
      <el-input v-model="detail.Bank" clearable />
    </el-form-item>
    <el-form-item label="账户号码" prop="Card">
      <el-input v-model="detail.Card" clearable />
    </el-form-item>
    <el-form-item label="联系地址" prop="Address">
      <el-input v-model="detail.Address" clearable />
    </el-form-item>
    <el-row :gutter="20">
      <el-col :span="12">
        <el-form-item label="联系人" prop="Linkman">
          <el-input v-model="detail.Linkman" clearable />
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item label="联系电话" prop="Linktel">
          <el-input v-model="detail.Linktel" clearable />
        </el-form-item>
      </el-col>
    </el-row>
    <el-form-item>
      <el-button type="primary" @click="onSubmit">提交</el-button>
    </el-form-item>
  </el-form>
</template>

<script>
export default {
  data () {
    return {
      loading: false,
      detail: this._detail,
    }
  },
  props: {
    _detail: {
      type: Object, default: () => {
        return {}
      }
    },
    layerid: { type: String, default: null }
  },
  methods: {
    //提交数据
    onSubmit () {
      this.$refs['ff'].validate(valid => {
        if (valid && !this.loading) {
          this.loading = true
          //处理数组
          this.$apis.organize.customer.submit(this.detail).then(res => {
            this.$parent.loadData()
            this.$layer.close(this.layerid)
            this.$message({ message: res || "数据提交成功！", type: "success" })
          }).catch(e => {
            this.$message.error(e || "执行错误")
          }).finally(() => {
            this.loading = false
          })
        }
      })
    }
  }
}
</script>
